
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '../../store/modules/user'
import { isValidUsername } from '@/utils/validate'

@Component({
  name: 'Login'
})
export default class extends Vue {
  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!isValidUsername(value)) {
      callback(new Error('Please enter the correct user name'))
    } else {
      callback()
    }
  }
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error('The password can not be less than 6 digits'))
    } else {
      callback()
    }
  }
  private loginForm = {
    username: '',
    password: ''
  }
  codeText: string = '获取验证码'
  disabledCodeBtn: boolean = true
  private loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }]
  }

  private showDialog = false
  private redirect?: string
  private otherQuery: Dictionary<string> = {}

  // @Watch('$route', { immediate: true })
  // private onRouteChange(route: Route) {
  //   // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
  //   // See https://github.com/vuejs/vue-router/pull/2050 for details
  //   const query = route.query as Dictionary<string>
  //   if (query) {
  //     // this.redirect = query.redirect
  //     this.redirect = '/course/table'
  //     this.otherQuery = this.getOtherQuery(query)
  //   }
  // }

  mounted() {
    if (this.loginForm.username === '') {
      (this.$refs.username as Input).focus()
    } else if (this.loginForm.password === '') {
      (this.$refs.password as Input).focus()
    }
  }

  async handleLogin() {
    const res = await UserModule.Login(this.loginForm)
    if (res.code === 200) {
      this.$message({
        type: 'success',
        message: '登录成功'
      })
      this.$router.push({ path: '/course/table' })
    } else {
      this.$message.error(res.message)
    }
  }

  // private getOtherQuery(query: Dictionary<string>) {
  //   return Object.keys(query).reduce((acc, cur) => {
  //     if (cur !== 'redirect') {
  //       acc[cur] = query[cur]
  //     }
  //     return acc
  //   }, {} as Dictionary<string>)
  // }

  async getCode() {
    if (!this.disabledCodeBtn) {
      return false
    }

    if (!this.loginForm.username) {
      this.$message({
        message: '手机号不能为空',
        type: 'warning'
      })
      return false
    }

    let data = {
      phone: this.loginForm.username
    }
    const res:any = await UserModule.getCode(data)
    if (res.code === 200) {
      this.countDown(60)
      this.$message({
        type: 'success',
        message: res.message
      })
      this.$emit('add-type', true)
    } else {
      this.$message.error(res.message)
    }
  }

  // 倒计时方法
  countDown(time) {
    if (time === 0) {
      this.disabledCodeBtn = true
      this.codeText = '获取验证码'
      return
    } else {
      this.disabledCodeBtn = false
      this.codeText = '重新发送(' + time + ')'
      time--
    }
    setTimeout(() => {
      this.countDown(time)
    }, 1000)
  }
}
